import { useAppSelector } from "@/core/root-reducer"
import populationStore from "@/entities/population/model/population.store"
import { Population } from "@/entities/population/model/population.types"
import PhysicalRiskUnitsSelector, {
  PhysicalRiskUnitContext
} from "@/entities/physical-risk/ui/PhysicalRiskUnitsSelector"
import physicalRiskStore from "@/entities/physical-risk/model/physical-risk.store"
import siteStore from "@/entities/site/model/site.store"
import { Site } from "@/entities/site/model/site.types"

interface Props {
  linkedPopulations: Population[]
  linkedSites: Site[]
  onChange: (sites: Site[], populations: Population[]) => void
}

export default function PhysicalRiskPerimeterStep({ linkedPopulations, linkedSites, onChange }: Props) {
  const sitesForRisk = useAppSelector(siteStore.selectors.listForRisk)
  const populationsForRisk = useAppSelector(populationStore.selectors.listForRisk)
  const draftRisk = useAppSelector(physicalRiskStore.selectors.draft)
  const isPersistedRisk = draftRisk.EstablishmentId !== null
  const selectedSites = isPersistedRisk ? sitesForRisk : linkedSites
  const selectedPopulations = isPersistedRisk ? populationsForRisk : linkedPopulations
  const selectedUnits: PhysicalRiskUnitContext[] =
    selectedSites.length || selectedPopulations.length
      ? [
          ...selectedSites.map((site) => ({ type: "site" as const, site })),
          ...selectedPopulations.map((population) => ({ type: "population" as const, population }))
        ]
      : [{ type: "establishment" }]

  function handleSelect(unit: PhysicalRiskUnitContext) {
    if (unit.type === "establishment") {
      onChange([], [])
      return
    }

    if (unit.type === "site") {
      onChange(
        selectedSites.some((site) => site.id === unit.site.id)
          ? selectedSites.filter((site) => site.id !== unit.site.id)
          : selectedSites.concat(unit.site),
        selectedPopulations
      )
      return
    }

    onChange(
      selectedSites,
      selectedPopulations.some((population) => population.id === unit.population.id)
        ? selectedPopulations.filter((population) => population.id !== unit.population.id)
        : selectedPopulations.concat(unit.population)
    )
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <PhysicalRiskUnitsSelector isMulti selectedUnits={selectedUnits} unitType="all" onSelect={handleSelect} />
    </div>
  )
}
